import BigNumber from "bignumber.js";

BigNumber.config({ EXPONENTIAL_AT: 18 });

export const percentToBps = (percent: string | number) =>
  new BigNumber(percent).multipliedBy(100).toString();
